"use strict";exports.__esModule = true;exports.symbol = symbol;function symbol() {
  // eslint-disable-next-line max-len,quotes
  return '<symbol viewbox="0 0 14 14" id=icon-add-small><path d="M13 6H8V1a1 1 0 10-2 0v5H1a1 1 0 100 2h5v5a1 1 0 002 0V8h5a1 1 0 000-2z"></path></symbol>';
}